/** @format */

import AppHeader from "./AppHeader";
import { Outlet, useNavigate } from "react-router-dom";
import { useState, useEffect, useLayoutEffect, useRef } from "react";
import EditLayoutModal from "./EditLayoutModal";
import TelecmiLiveCallModal from "../common/TelecmiLiveCallModal";
import Footer from "./footer";
import AiChatbot from "../ai-chatbot/AiChatbot";
// import SplashScreen from "../SplashScreen";
import "./css/MainLayout.css";
import jwt_decode from "jwt-decode";
import authApi from "../../api/authApi";
import { canShowAiChatbot } from "../../utils/entitlements";
import {
  TELECMI_OUTBOUND_CALL_FAILED,
  TELECMI_OUTBOUND_CALL_STARTED,
} from "../../utils/telecmiDialerBus";

const Main = ({ socket, crmSocket, onWhatsAppSettingChange }) => {
  const navigate = useNavigate();
  const telecmiCreateModalSeq = useRef(0);
  const [telecmiInboundCreate, setTelecmiInboundCreate] = useState(null);
  const [telecmiLiveEvents, setTelecmiLiveEvents] = useState([]);
  const [telecmiLiveModalOpen, setTelecmiLiveModalOpen] = useState(false);
  console.log("onwhh", onWhatsAppSettingChange);
  const [selectedWhatsAppSetting, setSelectedWhatsAppSetting] = useState(sessionStorage.getItem('selectedWhatsAppSetting') || '');
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [authGateOk, setAuthGateOk] = useState(false);
  // const [showSplash, setShowSplash] = useState(!localStorage.getItem('splashShown'));
  const [showSplash, setShowSplash] = useState(false);

  useLayoutEffect(() => {
    let cancelled = false;

    const redirectToLogin = () => {
      const pathname = window.location.pathname;
      const pathWithQuery = pathname + window.location.search;
      const excludedPaths = [
        "/login",
        "/reset-password",
        "/google-auth-callback",
        "/402",
        "/403",
        "/404",
      ];
      const isExcluded = excludedPaths.some(
        (p) => pathname === p || pathname.startsWith(p + "/")
      );
      const loginUrl = isExcluded
        ? "/login"
        : `/login?redirect=${encodeURIComponent(pathWithQuery)}`;
      window.location.replace(loginUrl);
    };

    const refreshAccessToken = async () => {
      const refreshed = await authApi.refreshToken();
      if (cancelled) return null;
      return refreshed ? localStorage.getItem("token") : null;
    };

    const runGate = async () => {
      let raw = localStorage.getItem("token");

      if (!raw || !String(raw).trim()) {
        raw = await refreshAccessToken();
        if (cancelled) return;
        if (!raw || !String(raw).trim()) {
          redirectToLogin();
          return;
        }
      }

      try {
        let decoded = jwt_decode(raw);
        if (!decoded.exp || decoded.exp * 1000 <= Date.now()) {
          const next = await refreshAccessToken();
          if (cancelled) return;
          if (!next || !String(next).trim()) {
            authApi.logout("SESSION_EXPIRED");
            return;
          }
          decoded = jwt_decode(next);
          if (!decoded.exp || decoded.exp * 1000 <= Date.now()) {
            authApi.logout("SESSION_EXPIRED");
            return;
          }
        }
      } catch (e) {
        console.error("Token validation error on gate:", e);
        if (cancelled) return;
        authApi.logout();
        return;
      }

      if (cancelled) return;
      setAuthGateOk(true);
    };

    runGate();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleWhatsAppSettingChange = (newSettingId) => {

    console.log("newSettingIdnewSettingId", newSettingId)
    setSelectedWhatsAppSetting(newSettingId);
    sessionStorage.setItem('selectedWhatsAppSetting', newSettingId);
  };

  useEffect(() => {
    const handleStorageChange = () => {
      setToken(localStorage.getItem('token'));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    if (onWhatsAppSettingChange) {
      onWhatsAppSettingChange(selectedWhatsAppSetting);
    }
  }, [selectedWhatsAppSetting, onWhatsAppSettingChange]);

  useEffect(() => {
    if (!crmSocket) {
      return undefined;
    }
    console.log("[TeleCMI socket] listening for telecmi_inbound_crm_record", {
      socketId: crmSocket.id,
      connected: crmSocket.connected,
    });
    const onTelecmiInbound = (data) => {
      console.log("[TeleCMI socket] event telecmi_inbound_crm_record", data);
      try {
        const authToken =
          localStorage.getItem("token") ||
          localStorage.getItem("watconnect_token");
        if (!authToken) {
          console.log("[TeleCMI socket] skip navigate: no auth token");
          return;
        }
        if (!data?.companyid || !data?.objectName || !data?.recordId) {
          console.log("[TeleCMI socket] skip navigate: incomplete payload", {
            companyid: data?.companyid,
            objectName: data?.objectName,
            recordId: data?.recordId,
          });
          return;
        }
        const decoded = jwt_decode(authToken);
        const jwtCompany = String(decoded.companyid || "");
        const payloadCompany = String(data.companyid);
        if (jwtCompany !== payloadCompany) {
          console.log("[TeleCMI socket] skip navigate: company mismatch", {
            jwtCompany,
            payloadCompany,
          });
          return;
        }
        const jwtUserId = String(
          decoded.id ?? decoded.userId ?? decoded.userid ?? ""
        ).trim();
        const targetUserId =
          data?.crmUserId != null ? String(data.crmUserId).trim() : "";
        if (!targetUserId || jwtUserId !== targetUserId) {
          console.log("[TeleCMI socket] skip navigate: not inbound agent user", {
            jwtUserId,
            targetUserId,
          });
          return;
        }
        const path = `/view/${encodeURIComponent(data.objectName)}/${encodeURIComponent(
          data.recordId
        )}`;
        console.log("[TeleCMI socket] navigating to", path);
        navigate(path);
      } catch (err) {
        console.warn("[TeleCMI socket] handler error", err);
      }
    };
    crmSocket.on("telecmi_inbound_crm_record", onTelecmiInbound);
    return () => {
      console.log("[TeleCMI socket] remove listener", {
        socketId: crmSocket.id,
      });
      crmSocket.off("telecmi_inbound_crm_record", onTelecmiInbound);
    };
  }, [crmSocket, navigate]);

  /** Outbound click-to-call: show dialer with "connecting" immediately (before webhooks). */
  useEffect(() => {
    const onOutboundStarted = (e) => {
      const authToken = localStorage.getItem("token");
      if (!authToken) return;
      const d = e.detail || {};
      setTelecmiLiveEvents([
        {
          status: "connecting",
          from: d.from != null ? d.from : null,
          to: d.to != null ? d.to : null,
          receivedAt: new Date().toISOString(),
          cmiuuid: null,
          direction: "outbound",
          clientOutbound: true,
        },
      ]);
      setTelecmiLiveModalOpen(true);
    };
    const onOutboundFailed = (e) => {
      const authToken = localStorage.getItem("token");
      if (!authToken) return;
      const d = e.detail || {};
      setTelecmiLiveEvents((prev) => {
        const base = Array.isArray(prev) ? [...prev] : [];
        base.push({
          status: "failed",
          from: d.from != null ? d.from : null,
          to: d.to != null ? d.to : null,
          receivedAt: new Date().toISOString(),
          cmiuuid: null,
          direction: "outbound",
          clientOutbound: true,
          errorMessage: d.message || "Call failed.",
        });
        while (base.length > 50) base.shift();
        return base;
      });
      setTelecmiLiveModalOpen(true);
    };
    window.addEventListener(TELECMI_OUTBOUND_CALL_STARTED, onOutboundStarted);
    window.addEventListener(TELECMI_OUTBOUND_CALL_FAILED, onOutboundFailed);
    return () => {
      window.removeEventListener(TELECMI_OUTBOUND_CALL_STARTED, onOutboundStarted);
      window.removeEventListener(TELECMI_OUTBOUND_CALL_FAILED, onOutboundFailed);
    };
  }, []);

  useEffect(() => {
    if (!crmSocket) {
      return undefined;
    }
    const MAX_LIVE = 50;
    const onTelecmiCallLive = (data) => {
      try {
        const authToken =
          localStorage.getItem("token") ||
          localStorage.getItem("watconnect_token");
        if (!authToken) {
          return;
        }
        if (!data?.companyid) {
          return;
        }
        const decoded = jwt_decode(authToken);
        const jwtCompany = String(decoded.companyid || "");
        if (jwtCompany !== String(data.companyid)) {
          return;
        }
        setTelecmiLiveEvents((prev) => {
          const next = Array.isArray(prev) ? [...prev] : [];
          next.push({
            status: data.status,
            cmiuuid: data.cmiuuid,
            direction: data.direction,
            from: data.from,
            to: data.to,
            leg: data.leg,
            user: data.user,
            receivedAt: data.receivedAt || new Date().toISOString(),
          });
          while (next.length > MAX_LIVE) {
            next.shift();
          }
          return next;
        });
        setTelecmiLiveModalOpen(true);
      } catch (err) {
        console.warn("[TeleCMI socket] telecmi_call_live handler error", err);
      }
    };
    crmSocket.on("telecmi_call_live", onTelecmiCallLive);

    const onTelecmiCallCdrComplete = (data) => {
      try {
        const authToken =
          localStorage.getItem("token") ||
          localStorage.getItem("watconnect_token");
        if (!authToken || !data?.companyid) {
          return;
        }
        const decoded = jwt_decode(authToken);
        const jwtCompany = String(decoded.companyid || "");
        if (jwtCompany !== String(data.companyid)) {
          return;
        }
        const cdrCmi =
          data?.cmiuuid != null ? String(data.cmiuuid).trim().toLowerCase() : "";
        if (!cdrCmi) {
          return;
        }
        setTelecmiLiveEvents((prev) => {
          const list = Array.isArray(prev) ? prev : [];
          const next = list.filter(
            (ev) =>
              String(ev.cmiuuid || "").trim().toLowerCase() !== cdrCmi
          );
          if (next.length === 0) {
            queueMicrotask(() => setTelecmiLiveModalOpen(false));
          }
          return next;
        });
      } catch (err) {
        console.warn(
          "[TeleCMI socket] telecmi_call_cdr_complete handler error",
          err
        );
      }
    };
    crmSocket.on("telecmi_call_cdr_complete", onTelecmiCallCdrComplete);

    return () => {
      crmSocket.off("telecmi_call_live", onTelecmiCallLive);
      crmSocket.off("telecmi_call_cdr_complete", onTelecmiCallCdrComplete);
    };
  }, [crmSocket]);

  useEffect(() => {
    if (!crmSocket) {
      return undefined;
    }
    const onNoCrmMatch = (data) => {
      console.log("[TeleCMI socket] event telecmi_inbound_no_crm_match", data);
      try {
        const authToken =
          localStorage.getItem("token") ||
          localStorage.getItem("watconnect_token");
        if (!authToken) {
          console.log("[TeleCMI socket] skip new lead modal: no auth token");
          return;
        }
        if (!data?.companyid || data?.phone == null || data?.phone === "") {
          console.log("[TeleCMI socket] skip new lead modal: incomplete payload", {
            companyid: data?.companyid,
            phone: data?.phone,
          });
          return;
        }
        const decoded = jwt_decode(authToken);
        const jwtCompany = String(decoded.companyid || "");
        const payloadCompany = String(data.companyid);
        if (jwtCompany !== payloadCompany) {
          console.log("[TeleCMI socket] skip new lead modal: company mismatch", {
            jwtCompany,
            payloadCompany,
          });
          return;
        }
        const jwtUserId = String(
          decoded.id ?? decoded.userId ?? decoded.userid ?? ""
        ).trim();
        const targetUserId =
          data?.crmUserId != null ? String(data.crmUserId).trim() : "";
        if (!targetUserId || jwtUserId !== targetUserId) {
          console.log(
            "[TeleCMI socket] skip new lead modal: not inbound agent user",
            { jwtUserId, targetUserId }
          );
          return;
        }
        telecmiCreateModalSeq.current += 1;
        setTelecmiInboundCreate({
          key: telecmiCreateModalSeq.current,
          phone: data.phone,
          leadPhoneField: data.leadPhoneField,
          leadSource: data?.lead_source ?? null,
          leadStatus: data?.lead_status ?? null,
        });
      } catch (err) {
        console.warn("[TeleCMI socket] telecmi_inbound_no_crm_match handler error", err);
      }
    };
    crmSocket.on("telecmi_inbound_no_crm_match", onNoCrmMatch);
    return () => {
      crmSocket.off("telecmi_inbound_no_crm_match", onNoCrmMatch);
    };
  }, [crmSocket]);

  useEffect(() => {
    if (!authGateOk) {
      return undefined;
    }
    const evaluateToken = async () => {
      let currentToken = localStorage.getItem('token');
      if (!currentToken || !String(currentToken).trim()) {
        const refreshed = await authApi.refreshToken();
        if (!refreshed) {
          authApi.logout();
        }
        return;
      }

      try {
        const { exp } = jwt_decode(currentToken);
        if (!exp || exp * 1000 <= Date.now()) {
          const refreshed = await authApi.refreshToken();
          if (!refreshed) {
            authApi.logout();
          }
        }
      } catch (error) {
        console.error("Token validation error in Main layout:", error);
        authApi.logout();
      }
    };

    evaluateToken();
    // Token validation every 15 minutes (900000 ms)
    const intervalId = window.setInterval(evaluateToken, 900000);
    return () => window.clearInterval(intervalId);
  }, [token, authGateOk]);

  // const handleSplashComplete = () => {
  //   setShowSplash(false);
  //   sessionStorage.setItem('splashShown', 'true');
  // };

  if (!authGateOk) {
    return (
      <div
        className="main-layout d-flex align-items-center justify-content-center"
        style={{ minHeight: "100vh" }}
      >
        <span className="text-muted">Redirecting…</span>
      </div>
    );
  }

  return (
    <>
      {/* {showSplash && <SplashScreen onComplete={handleSplashComplete} />} */}

      <div className="main-layout" style={{ display: 'flex' }}>
        <header className="main-header">
          <AppHeader
            socket={socket}
            crmSocket={crmSocket}
            onWhatsAppSettingChange={handleWhatsAppSettingChange}
          />
        </header>

        <main className="main-content">
          <Outlet />
        </main>

        <Footer />
        {canShowAiChatbot() && <AiChatbot />}

        <TelecmiLiveCallModal
          show={telecmiLiveModalOpen}
          onHide={() => {
            setTelecmiLiveModalOpen(false);
            setTelecmiLiveEvents([]);
          }}
          events={telecmiLiveEvents}
        />

        {telecmiInboundCreate && (
          <EditLayoutModal
            key={`telecmi-inbound-new-lead-${telecmiInboundCreate.key}`}
            show
            onHide={() => setTelecmiInboundCreate(null)}
            objectName="lead"
            id={null}
            isClone={false}
            sourcePage="telecmi_inbound"
            queryParams={{
              inboundPhone: telecmiInboundCreate.phone,
              inboundPhoneField: telecmiInboundCreate.leadPhoneField,
              inboundLeadSource: telecmiInboundCreate.leadSource,
              inboundLeadStatus: telecmiInboundCreate.leadStatus,
            }}
            onSave={(savedData) => {
              const recordId = savedData?.id ?? savedData?.data?.id;
              setTelecmiInboundCreate(null);
              if (recordId) {
                navigate(`/view/lead/${encodeURIComponent(recordId)}`);
              }
            }}
            onCancel={() => setTelecmiInboundCreate(null)}
          />
        )}
      </div>
    </>
  );
};

export default Main;
